import { isEqual } from 'lodash-es';
// @ts-ignore
import { isEmpty } from '@gp/utils/utils';
import { getUniqueKey } from '@gp/utils/common';
import { IStakeholdersData } from '@gp/pages/Pipeline/ProjectDetails/Stakeholder/components/StakeholderEdit/types';

export function getProjectCoreStakeholdersReducerActionType(
  type: string,
): string {
  if (!type || !type?.trim()) return '';
  return `PROJECT_CORE_STAKEHOLDERS___${type}`;
}

function addEmpOptions(data: any) {
  try {
    for (let i = 0; i < data.length; i++) {
      const stakeholder = data[i] || {};
      const organizations = stakeholder?.organization_list || [];
      for (let j = 0; j < organizations?.length; j++) {
        const organization = organizations[j] || {};
        const owners = organization?.owner_list || [];
        for (let k = 0; k < owners?.length; k++) {
          const owner = owners[k] || {};
          const emps = owner?.list || [];
          data[i].organization_list[j].owner_list[k].key = getUniqueKey();
          for (let m = 0; m < emps?.length; m++) {
            const emp = emps[m] || {};
            data[i].organization_list[j].owner_list[k].list[m].options = [
              {
                text: emp?.name || '',
                value: emp?.user_id || '',
              }
            ];
          }
        }
      }
    }
  } catch (exception) {
    console.warn(exception);
  }
}

export function getInitialStakeholdersData(initialData: any): IStakeholdersData[] {
  const defaultStakeholders: IStakeholdersData[] = [
    {
      stakeholder: 'Project Core Stakeholders',
      organization_list: [
        {
          organization: 'iegg',
          owner_list: [
            {
              project_owner: '',
              list: [],
            },
          ],
        },
        {
          organization: 'studio',
          owner_list: [
            {
              project_owner: '',
              list: [],
            },
          ],
        },
      ],
    },
  ];
  const initialStakeholders = initialData?.filter((item: any) => item?.stakeholder === 'Project Core Stakeholders');
  for (const defaultStakeholder of defaultStakeholders) {
    const targetStakeholder = initialStakeholders?.find((stakeholder: any) => stakeholder?.stakeholder === defaultStakeholder?.stakeholder);
    if (!targetStakeholder) continue;
    for (const defaultOrganization of defaultStakeholder?.organization_list) {
      const targetOrganization = targetStakeholder?.organization_list?.find((organization: any) => organization?.organization === defaultOrganization?.organization);
      if (!targetOrganization) continue;
      if (targetOrganization?.owner_list?.length) {
        defaultOrganization.owner_list = targetOrganization?.owner_list;
      }
    }
  }
  addEmpOptions(defaultStakeholders);
  return defaultStakeholders;
}

function createReqEmp(organization: string, project_owner: string, emp: any) {
  let result: any = {
    id: emp.id || null,
    organization: organization || '',
    project_owner: project_owner || '',
    user_name: emp.name || '',
    user_id: emp.user_id || '',
    position: emp.position || '',
    sort: emp?.sort || 0, // 新增的初始都为0
  };
  if (organization === 'studio') {
    result = {
      ...result,
      link: emp.link || '',
    };
  }
  return result;
}

function flatEmp(data: any) {
  const result = [];

  for (let i = 0; i < data?.length; i++) {
    const stakeholder = data?.[i] || {};
    if (stakeholder?.stakeholder === 'Project Core Stakeholders') {
      const organizations = stakeholder?.organization_list || [];
      for (let j = 0; j < organizations?.length; j++) {
        const organization = organizations?.[j] || {};
        const owners = organization?.owner_list || [];
        for (let k = 0; k < owners?.length; k++) {
          const owner = owners?.[k] || {};
          const emps = owner?.list || [];
          for (let m = 0; m < emps?.length; m++) {
            const emp = emps?.[m] || {};
            const reqEmp = createReqEmp(organization?.organization, owner?.project_owner, emp);
            result.push(reqEmp);
          }
        }
      }
    }
  }
  return result;
}

function isChanged(id: string | number, original: any[], present: any[]): boolean {
  const originalTarget = original?.find(item => item?.id === id);
  const presentTarget = present?.find(item => item?.id === id);
  return !isEqual(originalTarget, presentTarget);
}

export function createReqParams(original: any, present: any) {
  const originalEmps = flatEmp(original);
  const presentEmps = flatEmp(present);
  const presentEmpsIds = presentEmps?.map(item => item?.id);

  let ieggMaxSort = 0, studioMaxSort = 0; // 找到历史数值中iegg和studio各最大sort值
  for(let i = 0, l = originalEmps?.length; i < l; i ++) {
    const t = originalEmps?.[i];
    if (t?.organization == 'iegg' && t?.sort && t?.sort > ieggMaxSort) ieggMaxSort = t?.sort;
    if (t?.organization == 'studio' && t?.sort && t?.sort > studioMaxSort) studioMaxSort = t?.sort;
  }
  // 给每个数据整理好sort值，没有sort值时在历史数据最大sort值的基础上不断累加赋值，有sort值还是用原来的
  const sortPresentEmps: any[] = [];
  let ieggCount = ieggMaxSort, studioCount = studioMaxSort;
  for(let i = 0, l = presentEmps?.length; i < l; i ++) {
    const t = presentEmps?.[i];
    if (!t?.sort && t?.organization == 'iegg') ieggCount += 1;
    if (!t?.sort && t?.organization == 'studio') studioCount += 1;
    sortPresentEmps.push(t?.sort ? t : {...t, sort: t?.organization == 'iegg' ? ieggCount : studioCount});
  }

  const adds = sortPresentEmps?.filter(item => isEmpty(item?.id) && !isEmpty(item?.project_owner));
  const deletes1 = originalEmps?.filter(item => !presentEmpsIds?.includes(item?.id))?.map(item => item?.id);
  const deletes2 = sortPresentEmps?.filter(item => !isEmpty(item?.id) && isEmpty(item?.project_owner))?.map(item => item?.id);
  const deletes = [...deletes1, ...deletes2];
  const updates = sortPresentEmps?.filter(item => !isEmpty(item?.id) && !isEmpty(item?.project_owner) && isChanged(item?.id, originalEmps, sortPresentEmps));

  const res = {
    add: adds,
    delete: deletes,
    update: updates,
  };

  return res;
}
